import React from 'react';
import Button from '@components/atoms/button/button';
import Icon from '@components/atoms/icon/icon';
import sanitizer from '@helpers/sanitizer';
import extractFromContext from '@helpers/utils/extract-from-context';
import clsx from 'clsx';
import { GetServerSideProps, NextPageWithLayout } from 'next';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import { useTranslation } from 'next-i18next';
import DefaultLayout from '@layouts/default-layout';
import Environment from '@config/environment';
import { CF_RESIZING_PREFIX } from '@services/image-service';
import { getAppInitialProps } from '@helpers/initial-props';
import styles from './index.module.scss';

const SellerBadgesPage: NextPageWithLayout = () => {
  const { t } = useTranslation('seller-badges');

  const handleButtonClick = () => {
    window.location.href = window.location.origin + t('SELLER_BADGES.SECTION_1.BUTTON.LINK');
  };

  return (
    <>
      <div className={clsx(styles.sellerBadge)}>
        <h1 className={clsx(styles.sellerBadge__title, 'vc-title-m')}>{t('SELLER_BADGES.TITLE')}</h1>
        <section className={clsx(styles.sellerBadge__section, styles['sellerBadge__section--intro'])}>
          <img
            className={clsx(styles.sellerBadge__section__photo)}
            srcSet={`
              ${Environment.assetsPath}${CF_RESIZING_PREFIX}/f=auto,w=304,h=170,dpr=2/images/sellerRatingPage/trusted-expert-seller.jpg 304w,
              ${Environment.assetsPath}${CF_RESIZING_PREFIX}/f=auto,w=464,h=259,dpr=2/images/sellerRatingPage/trusted-expert-seller.jpg 464w,
              ${Environment.assetsPath}${CF_RESIZING_PREFIX}/f=auto,w=554,h=308,dpr=2/images/sellerRatingPage/trusted-expert-seller.jpg 554w
            `}
            sizes="(min-width: 1024px) 554px,(min-width: 768px) 464px, 304px"
            src={`
              ${Environment.assetsPath}${CF_RESIZING_PREFIX}/f=auto,w=554,h=308,dpr=2/images/sellerRatingPage/trusted-expert-seller.jpg
            `}
            height={311}
            width={494}
            alt={t('SELLER_BADGES.TRUSTED_SELLER')}
          />
          <p
            className={clsx(
              styles.sellerBadge__section__paragraph,
              styles['sellerBadge__section__paragraph--intro'],
              'vc-text-l',
            )}
          >
            <span dangerouslySetInnerHTML={{ __html: sanitizer(t('SELLER_BADGES.INTRO_FENX_PART_1')) }} />
            <span
              className={clsx(
                styles.sellerBadge__section__paragraph__badge,
                styles['sellerBadge__section__paragraph__badge--trusted'],
              )}
            >
              <img
                src={`${Environment.assetsPath}${CF_RESIZING_PREFIX}/f=auto,w=22,h=22,fit=crop,dpr=2/images/sellerRatingPage/badge-trusted-seller.png`}
                className={clsx(styles.sellerBadge__section__paragraph__badge__icon)}
                alt={t('SELLER_BADGES.ICON_ALT.TRUSTED_SELLER')}
              ></img>
              <span>{`${t('SELLER_BADGES.ICON_ALT.TRUSTED_SELLER')} `}</span>
            </span>
            {t('SELLER_BADGES.INTRO_FENX_PART_OR')}
            <span
              className={clsx(
                styles.sellerBadge__section__paragraph__badge,
                styles['sellerBadge__section__paragraph__badge--expert'],
              )}
            >
              <img
                src={`${Environment.assetsPath}${CF_RESIZING_PREFIX}/f=auto,w=22,h=22,fit=crop,dpr=2/images/sellerRatingPage/badge-expert-seller.png`}
                className={clsx(styles.sellerBadge__section__paragraph__badge__icon)}
                alt={t('SELLER_BADGES.ICON_ALT.EXPERT_SELLER')}
              ></img>
              <span>{`${t('SELLER_BADGES.ICON_ALT.EXPERT_SELLER')} `}</span>
            </span>
            <span dangerouslySetInnerHTML={{ __html: sanitizer(t('SELLER_BADGES.INTRO_FENX_PART_2')) }} />
          </p>
        </section>
        <section className={clsx(styles.sellerBadge__section)}>
          <h2 className={clsx(styles.sellerBadge__section__title, 'vc-title-s')}>
            {t('SELLER_BADGES.SECTION_1.TITLE')}
          </h2>
          <p
            className={clsx(
              styles.sellerBadge__section__paragraph,
              styles['sellerBadge__section__paragraph--sMargin'],
              'vc-text-m',
            )}
          >
            {t('SELLER_BADGES.SECTION_1.PARAGRAPH_1')}
          </p>
          <p className={clsx(styles.sellerBadge__section__paragraph, 'vc-text-m')}>
            {t('SELLER_BADGES.SECTION_1.PARAGRAPH_2')}
          </p>
          <div className={clsx(styles.sellerBadge__section__block, 'vc-importantText')}>
            <div
              className={clsx(
                styles.sellerBadge__section__block__badge,
                styles['sellerBadge__section__block__badge--trusted'],
              )}
            >
              <img
                className={clsx(styles['sellerBadge__section__block__badge--icon'])}
                srcSet={`
              ${Environment.assetsPath}${CF_RESIZING_PREFIX}/f=auto,w=304,h=170,dpr=2/images/sellerRatingPage/badge-trusted-seller.png 304w,
              ${Environment.assetsPath}${CF_RESIZING_PREFIX}/f=auto,w=464,h=259,dpr=2/images/sellerRatingPage/badge-trusted-seller.png 464w,
              ${Environment.assetsPath}${CF_RESIZING_PREFIX}/f=auto,w=554,h=308,dpr=2/images/sellerRatingPage/badge-trusted-seller.png 554w
            `}
                sizes="(min-width: 1024px) 554px,(min-width: 768px) 464px, 304px"
                src={`
              ${Environment.assetsPath}${CF_RESIZING_PREFIX}/f=auto,w=554,h=308,dpr=2/images/sellerRatingPage/badge-trusted-seller.png
            `}
                height={56}
                width={56}
                alt={t('SELLER_BADGES.ICON_ALT.TRUSTED_SELLER')}
              />
              <span className={clsx(styles.sellerBadge__section__block__label, 'vc-text-l')}>
                {t('SELLER_BADGES.TRUSTED_SELLER')}
              </span>
            </div>
            <div
              className={clsx(
                styles.sellerBadge__section__block__badge,
                styles['sellerBadge__section__block__badge--expert'],
              )}
            >
              <img
                className={clsx(styles['sellerBadge__section__block__badge--icon'])}
                srcSet={`
              ${Environment.assetsPath}${CF_RESIZING_PREFIX}/f=auto,w=304,h=170,dpr=2/images/sellerRatingPage/badge-expert-seller.png 304w,
              ${Environment.assetsPath}${CF_RESIZING_PREFIX}/f=auto,w=464,h=259,dpr=2/images/sellerRatingPage/badge-expert-seller.png 464w,
              ${Environment.assetsPath}${CF_RESIZING_PREFIX}/f=auto,w=554,h=308,dpr=2/images/sellerRatingPage/badge-expert-seller.png 554w
            `}
                sizes="(min-width: 1024px) 554px,(min-width: 768px) 464px, 304px"
                src={`
              ${Environment.assetsPath}${CF_RESIZING_PREFIX}/f=auto,w=554,h=308,dpr=2/images/sellerRatingPage/badge-expert-seller.png
            `}
                height={56}
                width={56}
                alt={t('SELLER_BADGES.ICON_ALT.EXPERT_SELLER')}
              />
              <span className={clsx(styles.sellerBadge__section__block__label, 'vc-text-l')}>
                {t('SELLER_BADGES.EXPERT_SELLER')}
              </span>
            </div>
          </div>
          <table className={clsx(styles.sellerBadge__table, 'vc-text-important')}>
            <thead>
              <tr>
                <th className={clsx(styles.sellerBadge__table__hcell)}>
                  <h3 className={clsx(styles['sellerBadge__table__hcell--title'], 'vc-text-l')}>
                    {t('SELLER_BADGES.SECTION_1.TABLE.TITLE')}
                  </h3>
                  <p className={clsx(styles['sellerBadge__table__hcell--subtitle'], 'vc-text-s')}>
                    {t('SELLER_BADGES.SECTION_1.TABLE.SUBTITLE')}
                  </p>
                </th>
                <th className={clsx(styles.sellerBadge__table__hcell)}>
                  <Icon
                    name="badge-trusted"
                    className={clsx(
                      styles.sellerBadge__table__hcell__icon,
                      styles['sellerBadge__table__hcell__icon--trusted'],
                    )}
                  />
                </th>
                <th className={clsx(styles.sellerBadge__table__hcell)}>
                  <Icon
                    name="badge-expert"
                    className={clsx(
                      styles.sellerBadge__table__hcell__icon,
                      styles['sellerBadge__table__hcell__icon--expert'],
                    )}
                  />
                </th>
              </tr>
            </thead>
            <tbody>
              <tr className={clsx(styles.sellerBadge__table__row)}>
                <td
                  className={clsx(styles.sellerBadge__table__cell, styles['sellerBadge__table__cell--criteria'])}
                  dangerouslySetInnerHTML={{ __html: sanitizer(t('SELLER_BADGES.SECTION_1.TABLE.LINE_1.CELL_1')) }}
                />
                <td
                  className={clsx(
                    styles.sellerBadge__table__cell,
                    styles['sellerBadge__table__cell--trusted'],
                    'vc-text-l',
                  )}
                >
                  {t('SELLER_BADGES.SECTION_1.TABLE.LINE_1.CELL_2')}
                </td>
                <td
                  className={clsx(
                    styles.sellerBadge__table__cell,
                    styles['sellerBadge__table__cell--expert'],
                    'vc-text-l',
                  )}
                >
                  {t('SELLER_BADGES.SECTION_1.TABLE.LINE_1.CELL_3')}
                </td>
              </tr>
              <tr className={clsx(styles.sellerBadge__table__row)}>
                <td
                  className={clsx(styles.sellerBadge__table__cell, styles['sellerBadge__table__cell--criteria'])}
                  dangerouslySetInnerHTML={{ __html: sanitizer(t('SELLER_BADGES.SECTION_1.TABLE.LINE_2.CELL_1')) }}
                />
                <td
                  className={clsx(
                    styles.sellerBadge__table__cell,
                    styles['sellerBadge__table__cell--trusted'],
                    'vc-text-l',
                  )}
                >
                  {t('SELLER_BADGES.SECTION_1.TABLE.LINE_2.CELL_2')}
                </td>
                <td
                  className={clsx(
                    styles.sellerBadge__table__cell,
                    styles['sellerBadge__table__cell--expert'],
                    'vc-text-l',
                  )}
                >
                  {t('SELLER_BADGES.SECTION_1.TABLE.LINE_2.CELL_3')}
                </td>
              </tr>
              <tr className={clsx(styles.sellerBadge__table__row)}>
                <td
                  className={clsx(styles.sellerBadge__table__cell, styles['sellerBadge__table__cell--criteria'])}
                  dangerouslySetInnerHTML={{ __html: sanitizer(t('SELLER_BADGES.SECTION_1.TABLE.LINE_3.CELL_1')) }}
                />
                <td
                  className={clsx(
                    styles.sellerBadge__table__cell,
                    styles['sellerBadge__table__cell--trusted'],
                    'vc-text-l',
                  )}
                  dangerouslySetInnerHTML={{ __html: sanitizer(t('SELLER_BADGES.SECTION_1.TABLE.LINE_3.CELL_2')) }}
                />
                <td
                  className={clsx(
                    styles.sellerBadge__table__cell,
                    styles['sellerBadge__table__cell--expert'],
                    'vc-text-l',
                  )}
                  dangerouslySetInnerHTML={{ __html: sanitizer(t('SELLER_BADGES.SECTION_1.TABLE.LINE_3.CELL_3')) }}
                />
              </tr>
            </tbody>
          </table>
        </section>
        <section className={clsx(styles.sellerBadge__section)}>
          <div className={clsx(styles.sellerBadge__section__lists__container)}>
            <h2 className={clsx('vc-title-s')}>{t('SELLER_BADGES.SECTION_LISTS.TITLE')}</h2>
            <ul className={clsx(styles.sellerBadge__section__tips__list)}>
              <li className={clsx(styles.sellerBadge__section__tips__list__item)}>
                <h4>{t('SELLER_BADGES.SECTION_LISTS.TITLE_1')}</h4>
                <ul>
                  <li className={clsx(styles.sellerBadge__tips__list__item, 'vc-text-m')}>
                    {t('SELLER_BADGES.SECTION_LISTS.TIPS_1')}
                  </li>
                  <li className={clsx(styles.sellerBadge__tips__list__item, 'vc-text-m')}>
                    {t('SELLER_BADGES.SECTION_LISTS.TIPS_2')}
                  </li>
                  <li className={clsx(styles.sellerBadge__tips__list__item, 'vc-text-m')}>
                    {t('SELLER_BADGES.SECTION_LISTS.TIPS_3')}
                  </li>
                </ul>
                <h4>{t('SELLER_BADGES.SECTION_LISTS.TITLE_2')}</h4>
                <ul>
                  <li className={clsx(styles.sellerBadge__tips__list__item, 'vc-text-m')}>
                    {t('SELLER_BADGES.SECTION_LISTS.TIPS_4')}
                  </li>
                  <li className={clsx(styles.sellerBadge__tips__list__item, 'vc-text-m')}>
                    {t('SELLER_BADGES.SECTION_LISTS.TIPS_5')}
                  </li>
                </ul>
              </li>
              <li className={clsx(styles.sellerBadge__section__tips__list__item)}>
                <h4>{t('SELLER_BADGES.SECTION_LISTS.TITLE_3')}</h4>
                <ul className={clsx(styles.sellerBadge__section__tips__list__item__last)}>
                  <li className={clsx(styles.sellerBadge__tips__list__item, 'vc-text-m')}>
                    {t('SELLER_BADGES.SECTION_LISTS.TIPS_6')}
                  </li>
                  <li className={clsx(styles.sellerBadge__tips__list__item, 'vc-text-m')}>
                    {t('SELLER_BADGES.SECTION_LISTS.TIPS_7')}
                  </li>
                  <li className={clsx(styles.sellerBadge__tips__list__item, 'vc-text-m')}>
                    {t('SELLER_BADGES.SECTION_LISTS.TIPS_8')}
                  </li>
                  <li className={clsx(styles.sellerBadge__tips__list__item, 'vc-text-m')}>
                    {t('SELLER_BADGES.SECTION_LISTS.TIPS_9')}
                  </li>
                </ul>
              </li>
            </ul>
          </div>
          <Button
            onClick={handleButtonClick}
            size="medium"
            fullWidth
            notFullWidthQuery="md-up"
            variant="primary"
          >
            {t('SELLER_BADGES.SECTION_1.BUTTON.NAME')}
          </Button>
        </section>
        <section
          className={clsx(styles.sellerBadge__section)}
          id="badge__benefits"
        >
          <h2 className={clsx(styles.sellerBadge__section__title, 'vc-title-s')}>
            {t('SELLER_BADGES.SECTION_2.TITLE')}
          </h2>
          <table className={clsx(styles.sellerBadge__table)}>
            <thead>
              <tr className={clsx(styles.sellerBadge__table__head)}>
                <th className={clsx(styles.sellerBadge__table__hcell)}>
                  <h3 className={clsx(styles['sellerBadge__table__hcell--title'], 'vc-text-l')}>
                    {t('SELLER_BADGES.SECTION_2.TABLE.TITLE')}
                  </h3>
                </th>
                <th className={clsx(styles.sellerBadge__table__hcell)}>
                  <Icon
                    name="badge-trusted"
                    className={clsx(
                      styles.sellerBadge__table__hcell__icon,
                      styles['sellerBadge__table__hcell__icon--trusted'],
                    )}
                  />
                </th>
                <th className={clsx(styles.sellerBadge__table__hcell)}>
                  <Icon
                    name="badge-expert"
                    className={clsx(
                      styles.sellerBadge__table__hcell__icon,
                      styles['sellerBadge__table__hcell__icon--expert'],
                    )}
                  />
                </th>
              </tr>
            </thead>
            <tbody>
              <tr className={clsx(styles.sellerBadge__table__row)}>
                <td className={clsx(styles.sellerBadge__table__cell, styles['sellerBadge__table__cell--benefits'])}>
                  {t('SELLER_BADGES.SECTION_2.TABLE.LINE_2.CELL_1')}
                </td>
                <td className={clsx(styles.sellerBadge__table__cell, styles['sellerBadge__table__cell--trusted'])}>
                  +
                </td>
                <td className={clsx(styles.sellerBadge__table__cell, styles['sellerBadge__table__cell--expert'])}>
                  ++
                </td>
              </tr>
              <tr className={clsx(styles.sellerBadge__table__row)}>
                <td className={clsx(styles.sellerBadge__table__cell, styles['sellerBadge__table__cell--benefits'])}>
                  {t('SELLER_BADGES.SECTION_2.TABLE.LINE_3.CELL_1')}
                </td>
                <td className={clsx(styles.sellerBadge__table__cell, styles['sellerBadge__table__cell--trusted'])}>
                  +
                </td>
                <td className={clsx(styles.sellerBadge__table__cell, styles['sellerBadge__table__cell--expert'])}>
                  ++
                </td>
              </tr>
            </tbody>
          </table>
          <p className={clsx(styles.sellerBadge__section__paragraph)}>{t('SELLER_BADGES.SECTION_2.PARAGRAPH_1')}</p>
        </section>
      </div>
    </>
  );
};

SellerBadgesPage.Layout = [DefaultLayout];
SellerBadgesPage.PageType = 'SellerBadgesPage';

export const getServerSideProps: GetServerSideProps = async (context) => {
  const { locale } = extractFromContext(context);
  const initialProps = await getAppInitialProps(context);
  const translations = await serverSideTranslations(locale, ['default-layout', 'seller-badges', 'common']);

  return {
    props: {
      ...initialProps,
      ...translations,
    },
  };
};

export default SellerBadgesPage;
